import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-extralight tracking-widest text-left w-full" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "pl-10 flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-0 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-4 mr-4",
    viewBox: "0 0 8.167 21.079"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      stroke: "currentcolor",
      "stroke-width": "1.5px",
      d: "M3471.226,2026.9l6.642,10.184-6.642,10.073",
      transform: "translate(-3470.597 -2026.494)"
    })
  ])
], -1)
const _hoisted_5 = { class: "pl-10 flex-grow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-0 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-4 mr-4",
    viewBox: "0 0 8.167 21.079"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      stroke: "currentcolor",
      "stroke-width": "1.5px",
      d: "M3471.226,2026.9l6.642,10.184-6.642,10.073",
      transform: "translate(-3470.597 -2026.494)"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    (_ctx.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.link,
          target: "_blank",
          class: _normalizeClass(["cursor-pointer w-full leading-10 flex", {
        'bg-brand-bg text-brand-promo-bg hover:bg-brand-promo-bg hover:text-white':
          !_ctx.inverseStyle,
        'hover:bg-brand-bg hover:text-brand-promo-bg bg-brand-promo-bg text-white':
          _ctx.inverseStyle,
      }])
        }, [
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _hoisted_4
        ], 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["cursor-pointer w-full leading-10 flex", {
        'bg-brand-bg text-brand-promo-bg hover:bg-brand-promo-bg hover:text-white':
          !_ctx.inverseStyle,
        'hover:bg-brand-bg hover:text-brand-promo-bg bg-brand-promo-bg text-white':
          _ctx.inverseStyle,
      }])
        }, [
          _createElementVNode("span", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _hoisted_6
        ], 2))
  ]))
}